<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="shopsSelected"
    :clearable="!unclearable"
    :items="shopsItems"
    :loading="shopsLoading"
    :search-input.sync="shopsSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $consts.shopName()"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import Shops from "@/api/shops";

export default {
  name: "SearcherShop",

  props: {
    value: Object,
    districtID: Number,
    allianceBusinessIds: Array,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  computed: {
    shopsItems() {
      return this.shops.map((shop) => {
        const Description = shop.shop_code + " / " + shop.shop_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == shop.id
            )
          : false;
        return Object.assign({}, shop, { Description, disabled });
      });
    },
  },

  data: () => ({
    shops: [],
    shopsLoading: false,
    shopsSearch: "",
    shopsSelected: null,
  }),

  mounted() {
    this.getShopsFromAPI();
  },

  methods: {
    getShopsFromAPI() {
      this.shopsLoading = true;
      Shops.fetchAllForSelect({
        district_id: this.districtID,
        alliance_business_ids: this.allianceBusinessIds,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.shops = response.data.shops;
            }
            this.shopsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.shopsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.shopsSelected = this.value;
      },
    },
    shopsSelected: {
      handler() {
        this.$emit("input", this.shopsSelected);
      },
    },
    districtID: {
      handler() {
        this.getShopsFromAPI();
      },
    },
    allianceBusinessIds: {
      handler() {
        this.getShopsFromAPI();
      },
    },
  },
};
</script>
